import { Component, OnInit } from '@angular/core';
import { BankService } from '../service/bank.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-bank-create',
  templateUrl: './bank-create.component.html',
  styleUrls: ['./bank-create.component.css']
})
export class BankCreateComponent {
  model: any = {
    BankNumber: null,
    BankName: null
  };
  msgs: any[] = [];
  constructor(private dataService: BankService) { }
  sendData(data: NgForm): any {
    if (data.valid) {
      this.model.BankName = this.model.BankName == null ? "" : this.model.BankName;
      this.dataService.post(this.model).subscribe((result: any) => {
        if (result == "Sucssess") {
          this.showMessage('success', '', 'ההוספה נשמרה בהצלחה');
          this.model = {};
          data.reset();
        } else {
          this.showMessage('error', '', 'תקלה בשמירה');
        }
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בשמירה');
        });
    } else {
      this.showMessage('error', '', 'מספר חשבון הינו שדה חובה');
    }
  }
  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/bank-create/bank-create.component.ts